<template>
<div>
    <section class="reship_centered-nav-section">
        <div class="reship_checkoutnav_wrap">
            <div class="reship_checkoutnav_div">
                <a href="#" class="reship_link-block-73 w-inline-block">
                    <img sizes="(max-width: 1030px) 100vw, 1030px" srcset="@/assets/images/OhMyMeds_Logo.svg 500w, @/assets/images/OhMyMeds_Logo.svg 800w, @/assets/images/OhMyMeds_Logo.svg 1030w" alt="" src="@/assets/images/OhMyMeds_Logo.svg" loading="lazy" class="reship_image-487">
                </a>
                <div class="reship_checkoutnav_progressdiv">
                    <div class="reship_progress_step_div" :class="{ 'reship_current': currentStep === 1 }"></div>
                    <div class="reship_progress_step_div" :class="{ 'reship_current': currentStep === 2 }"></div>
                    <div class="reship_progress_step_div" :class="{ 'reship_current': currentStep === 3 }"></div>
                    <div class="reship_progress_step_div" :class="{ 'reship_current': currentStep === 4 }"></div>
                </div>
            </div>
        </div>
    </section>

    <section class="reship_form-section">
        <div class="reship_form-main-div">
            <!-- Step 1: Choose Items to Reship -->
            <div class="reship_reshipform_blockdiv" v-show="currentStep === 1">
                <div class="reship_text-block">Replacement Request Form</div>
                <p class="reship_paragraph">Missing or damaged item? Let us know what happened — we're here to help.</p>
                <p class="reship_paragraph" style="font-size: 16px;">To ensure prompt service, all replacement requests must be submitted within 7 days of receiving your order. Each request will be reviewed on a case-by-case basis.</p>
                <div class="reship_block-headers">Choose Items </div>
                <div class="reship_form-block w-form">
                    <form @submit.prevent="goToStep2" class="reship_form">
                        <div v-if="itemsShipped.length > 0">
                            <div class="reship_checkbox-item" v-for="item in itemsShipped[0].orders" :key="item.external_order_number" @click="toggleItem(item.external_order_number)" :class="{ 'selected': selectedItems.includes(item.external_order_number) }">

                                <div class="reship_custom-checkbox">
                                    <span v-if="selectedItems.includes(item.external_order_number)" class="reship_checkbox-mark">✓</span>
                                </div>

                                <div class="reship_checkbox-label">
                                    {{ item.med_name }}
                                </div>

                                <!-- Hidden input for form submission -->
                                <input type="checkbox" :value="item.external_order_number" v-model="selectedItems" style="display: none;">
                            </div>
                        </div>
                        <div v-else-if="!isLoading">
                            <p>No items available for reshipping.</p>
                        </div>
                        <div v-if="isLoading">
                            <p>Loading items... please wait</p>
                        </div>

                        <button type="submit" class="reship_button w-button-ship" :disabled="selectedItems.length === 0">
                            Continue →
                        </button>
                        <div v-if="selectedItems.length === 0 && !isLoading" class="error-message">
                            Please select at least one item to continue.
                        </div>
                    </form>
                </div>
            </div>

            <!-- Step 2: Why You Need A Reship -->
            <div class="reship_reshipform_blockdiv" v-show="currentStep === 2">
                <div class="reship_text-block">Why You Need A Reship</div>
                <p class="reship_paragraph">Please explain the reason for your reshipping request (maximum 1000 characters).</p>

                <div class="reship_form-block w-form">
                    <form @submit.prevent="goToStep3" class="reship_form">
                        <div class="reason-textarea-container">
                            <textarea v-model="selectedReason" placeholder="Please describe why you need a reship..." maxlength="1000" rows="6" class="reship_textarea w-input" :class="{ 'error': selectedReason.trim().length === 0 && showReasonError }"></textarea>
                            <div class="character-count">
                                {{ selectedReason.length }}/1000 characters
                            </div>
                        </div>

                        <div class="reship_form-buttons">

                            <button type="submit" class="reship_button w-button-ship" :disabled="selectedReason.trim().length === 0">
                                Continue →
                            </button>
                        </div>
                        <div v-if="selectedReason.trim().length === 0 && showReasonError" class="error-message">
                            Please enter a reason to continue.
                        </div>
                    </form>
                </div>
            </div>

            <!-- Step 3: Submit Evidence -->
            <!-- Updated template section for Step 3 -->
<div class="reship_reshipform_blockdiv" v-show="currentStep === 3">
    <div class="reship_block-headers">Submit Evidence</div>
    <p class="reship_paragraph">Please upload an image of your current product as evidence for the reshipping request.</p>

    <div class="reship_form-block w-form">
        <form @submit.prevent="submitReshipRequest" class="reship_form">
            <div class="upload-box" :class="{ 'has-file': uploadedFile }">
                <input type="file" ref="fileInput" @change="handleFileUpload" accept="image/*" style="display: none;">
                <div class="upload-content" @click.prevent="$refs.fileInput.click()">
                    <!-- Show upload prompt when no file is selected -->
                    <div v-if="!uploadedFile" class="upload-prompt">
                        <i class="upload-icon"><img src="@/assets/images/upload-icon.svg"></i>
                        <p>Drop image here or click to upload</p>
                        <p class="file-size-info">Maximum file size: 5 MB</p>
                    </div>
                    <!-- Show file info when file is selected -->
                    <div v-else class="file-selected">
                        <i class="file-icon">📎</i>
                        <div class="file-info">
                            <p class="file-name">{{ uploadedFileName }}</p>
                            <p class="file-size">{{ formatFileSize(uploadedFile.size) }}</p>
                        </div>
                        <button type="button" @click.stop="removeFile" class="remove-file-btn">✕</button>
                    </div>
                </div>
            </div>
            
            <div class="reship_form-buttons">
                <button type="submit" :disabled="!uploadedFile || isSubmitting" class="reship_button w-button-ship">
                    {{ isSubmitting ? 'Submitting...' : 'Submit →' }}
                </button>
            </div>

            <div v-if="!uploadedFile" class="error-message">
                Please upload an image to continue.
            </div>
            <div v-if="fileError" class="error-message">
                {{ fileError }}
            </div>
        </form>
    </div>
</div>

            <div class="reship_reshipform_blockdiv" v-show="currentStep === 4">
                <div class="reship_block-headers">Thank you! Your request have been received. We will review and get back to you with any clarification needed</div>
                <div class="reship_form-block w-form">
                    <div class="reship_form-buttons">
                            <button @click.prevent="pushToHome()" class="reship_button w-button-ship" style="width: 100%;">Go To Dashboard
                            </button>
                        </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
export default {
    name: 'ReshippingRequest',
    data() {
        return {
            isLoading: true,
            itemsShipped: [],
            currentStep: 1,
            selectedItems: [],
            selectedReason: '',
            uploadedFile: null,
            fileError: '',
            isSubmitting: false,
            showThankYou: false,
            showReasonError: false,
            uploadedFileName: '', // Add this new property
        }
    },
    computed: {
        isLoggedin() {
            return this.$store.getters.isAuthenticated;
        },

    },
    methods: {
        goToStep1() {
            this.currentStep = 1;
        },
        async fetchProductsShipped() {
            if (!this.isLoggedin) {
                this.$router.push({
                    path: '/login',
                    query: {
                        page_ref: this.$route.fullPath,
                    }
                });
                return;
            }

            try {
                this.isLoading = true;
                const response = await this.$axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/get-shipped-items`);

                if (response.data.success) {
                    if (response.data.items.length > 0) {
                        this.itemsShipped = response.data.items;
                    } else {
                        this.$router.push('/sorry?message=No items available for reshipping. Please contact support.');
                    }
                } else {
                    this.$router.push('/sorry?message=An error occurred while getting items shipped. Please contact support.');
                }
            } catch (error) {
                console.error('Error fetching shipped items:', error);
                this.$router.push('/sorry?message=An error occurred while getting items shipped. Please contact support.');
            } finally {
                this.isLoading = false;
            }
        },
        pushToHome(){
            this.$router.push('/home');
        },
        toggleItem(orderNumber) {
            const index = this.selectedItems.indexOf(orderNumber);
            if (index > -1) {
                // Item is selected, remove it
                this.selectedItems.splice(index, 1);
            } else {
                // Item is not selected, add it
                this.selectedItems.push(orderNumber);
            }
        },

        goToStep2() {
            if (this.selectedItems.length === 0) {
                return;
            }
            this.currentStep = 2;
        },

        goToStep3() {
            if (this.selectedReason.trim().length === 0) {
                this.showReasonError = true;
                return;
            }
            this.showReasonError = false;
            this.currentStep = 3;
        },

        
// Update your handleFileUpload method
handleFileUpload(event) {
    const file = event.target.files[0];
    this.fileError = '';

    if (!file) {
        this.uploadedFile = null;
        this.uploadedFileName = '';
        return;
    }

    // Validate file type
    if (!file.type.startsWith('image/')) {
        this.fileError = 'Please select an image file.';
        this.uploadedFile = null;
        this.uploadedFileName = '';
        return;
    }

    // Validate file size (5MB = 5 * 1024 * 1024 bytes)
    if (file.size > 5 * 1024 * 1024) {
        this.fileError = 'File size must be less than 5MB.';
        this.uploadedFile = null;
        this.uploadedFileName = '';
        return;
    }

    this.uploadedFile = file;
    this.uploadedFileName = file.name; // Store the file name
},

// Add these new methods
removeFile() {
    this.uploadedFile = null;
    this.uploadedFileName = '';
    this.fileError = '';
    // Reset the file input
    if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
    }
},

formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
},

        async submitReshipRequest() {
    if (!this.uploadedFile || this.isSubmitting) {
        return;
    }

    try {
        this.isSubmitting = true;
        console.log('🔄 Starting reship request submission...');

        // Step 1: Upload image to S3 and WAIT for it to complete
        console.log('⏳ Uploading image to S3...');
        const imageUrl = await this.uploadImageToS3(this.uploadedFile);
        console.log('✅ Image uploaded successfully:', imageUrl);

        // Step 2: Only proceed if we have a valid image URL
        if (!imageUrl) {
            throw new Error('Failed to get image URL from S3 upload');
        }

        // Step 3: Prepare payload
        const selectedItemsData = this.selectedItems.map(orderNumber => {
            const item = this.itemsShipped[0].orders.find(order => order.external_order_number === orderNumber);
            return {
                name: item.med_name,
                id: item.external_order_number
            };
        });

        const payload = {
            reason: this.selectedReason,
            image: imageUrl,
            items: selectedItemsData
        };

        console.log('📤 Submitting final payload:', payload);

        // Step 4: Submit to backend and WAIT for response
        const response = await this.$axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/api/submit-reship-request`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        console.log('✅ Final API response:', response.data);

        if (response.data.success) {
            this.currentStep = 4;
        } else {
            alert('Error submitting request: ' + (response.data.message || 'Unknown error'));
        }
    } catch (error) {
        console.error('💥 Error in submitReshipRequest:', error);
        alert('An error occurred while submitting your request: ' + error.message);
    } finally {
        this.isSubmitting = false;
    }
},

async uploadImageToS3(file) {
    try {
        const timestamp = Date.now();
        const randomStr = Math.random().toString(36).substring(2, 15);
        const fileExtension = file.name.split('.').pop();
        const filename = `reship-evidence/${timestamp}-${randomStr}.${fileExtension}`;

        console.log('🔄 Starting S3 upload for:', filename);

        // Step 1: Get signed URL and WAIT for response
        console.log('⏳ Getting signed URL...');
        const signedUrlResponse = await this.getSignedUrl(filename, file.type);
        console.log('✅ Got signed URL response:', signedUrlResponse);

        // Step 2: Validate the response
        if (!signedUrlResponse || !signedUrlResponse.success) {
            throw new Error('Failed to get signed URL: ' + (signedUrlResponse?.message || 'Invalid response'));
        }

        if (!signedUrlResponse.url) {
            throw new Error('No upload_url in signed URL response');
        }

        // Step 3: Upload to S3 and WAIT for completion
        console.log('⏳ Uploading to S3...');
        const uploadResponse = await fetch(signedUrlResponse.url, {
            method: 'PUT',
            headers: {
                'Content-Type': file.type,
            },
            body: file
        });

        console.log('📊 S3 upload response:', {
            status: uploadResponse.status,
            ok: uploadResponse.ok,
            statusText: uploadResponse.statusText
        });

        if (!uploadResponse.ok) {
            const errorText = await uploadResponse.text();
            throw new Error(`S3 upload failed: ${uploadResponse.status} - ${errorText}`);
        }

        // Step 4: Return the public URL
        const publicUrl = signedUrlResponse.public_url || signedUrlResponse.url;
        console.log('✅ S3 upload complete, returning URL:', publicUrl);
        return publicUrl;

    } catch (error) {
        console.error('💥 Error in uploadImageToS3:', error);
        throw error; // Re-throw so submitReshipRequest can handle it
    }
},

async getSignedUrl(filename, contentType) {
    try {
        console.log('⏳ Requesting signed URL...');
        
        const response = await this.$axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/api/get-signed-url`,
            {
                filename,
                content_type: contentType
            }
        );

        console.log('✅ Signed URL API response:', response);
        console.log('✅ Response data:', response.data);

        // Make sure we actually got data
        if (!response.data) {
            throw new Error('No data received from signed URL API');
        }

        return response.data;
    } catch (error) {
        console.error('💥 Error getting signed URL:', error);
        throw error;
    }
},

        closeThankYou() {
            this.showThankYou = false;
            // Redirect to a success page or reset the form
            this.$router.push('/');
        }
    },
    mounted() {
        this.fetchProductsShipped();
    }
}
</script>

<style scoped>
/* Navigation Section */
.reship_centered-nav-section {
    z-index: 999;
    position: static;
    inset: 0% 0% auto;
}

.reship_checkoutnav_wrap {
    background-image: linear-gradient(#fff 80%, #fff0);
    flex-flow: column;
    align-items: center;
    display: flex;
}

.reship_checkoutnav_div {
    flex-flow: column;
    align-items: center;
    width: 600px;
    padding-top: 20px;
    padding-bottom: 10px;
    display: flex;
}

.reship_link-block-73 {
    margin-bottom: 0;
}

.reship_image-487 {
    height: 50px;
}

.reship_checkoutnav_progressdiv {
    justify-content: space-between;
    align-items: center;
    width: 60%;
    margin-bottom: 30px;
    display: none;
}

.reship_progress_step_div {
    background-color: #f3f3f3;
    border-radius: 99px;
    width: 23%;
    height: 6px;
}

.reship_progress_step_div.reship_current {
    background-color: #c9e8ff;
    height: 6px;
}

/* Form Section */
.reship_form-section {
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    display: flex;
}

.reship_form-main-div {
    flex-flow: column;
    justify-content: flex-start;
    align-items: stretch;
    width: 550px;
    padding-top: 60px;
    padding-bottom: 80px;
    display: flex;
}

.reship_reshipform_blockdiv {
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 100px;
    display: flex;
}

.reship_text-block {
    font-family: var(--inter);
    color: var(--black);
    text-align: center;
    margin-bottom: 15px;
    font-size: 36px;
    font-weight: 900;
    line-height: 40px;
}

.reship_paragraph {
    font-family: var(--inter);
    color: var(--black);
    text-align: center;
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 24px;
}

.reship_block-headers {
    font-family: var(--inter);
    color: var(--black);
    text-align: center;
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 33px;
}

.reship_form-block {
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    display: flex;
}

.reship_form {
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    display: flex;
}

/* Checkbox Item Styles */
.reship_checkbox-item {
    display: flex;
    align-items: center;
    padding: 16px;
    margin-bottom: 12px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: #fff;
    min-height: 60px;
}

.reship_checkbox-item:hover {
    border-color: #007bff;
    background-color: #f8f9fa;
}

.reship_checkbox-item.selected {
    border-color: #007bff;
    background-color: #e7f3ff;
}

.reship_custom-checkbox {
    width: 32px;
    height: 32px;
    border: 3px solid #ccc;
    border-radius: 6px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    flex-shrink: 0;
    transition: all 0.2s ease;
}

.reship_checkbox-item.selected .reship_custom-checkbox {
    background-color: #007bff;
    border-color: #007bff;
}

.reship_checkbox-mark {
    color: white;
    font-weight: bold;
    font-size: 20px;
    line-height: 1;
}

.reship_checkbox-label {
    flex: 1;
    line-height: 1.4;
    color: #333;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
}

/* Textarea Container */
.reason-textarea-container {
    margin: 1rem 0;
    position: relative;
    width: 100%;
}

.reship_textarea {
    width: 100%;
    min-height: 120px;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-family: inherit;
    font-size: 1rem;
    resize: vertical;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.reship_textarea:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.reship_textarea.error {
    border-color: #dc3545;
}

.character-count {
    position: absolute;
    bottom: -20px;
    right: 0;
    font-size: 0.875rem;
    color: #6c757d;
}

/* Upload Section */
.reship_upload-div {
    grid-column-gap: 15px;
    grid-row-gap: 15px;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 40px;
    display: flex;
}

.reship_link-block-74 {
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    background-color: var(--f5-grey);
    font-family: var(--inter);
    color: var(--black);
    justify-content: flex-start;
    align-items: center;
    width: 36%;
    padding: 16px;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    display: flex;
}

.reship_image-488 {
    width: 25px;
}

.reship_text-block-5 {
    font-family: var(--inter);
    color: var(--black);
    font-size: 14px;
    line-height: 22px;
}

/* Form Buttons */
.reship_form-buttons {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-top: 1.5rem;
    flex-wrap: wrap;
    width: 100%
}

.reship_button {
    background-color: var(--green);
    font-family: var(--inter);
    color: var(--white);
    text-align: center;
    border-radius: 9px;
    width: 50%;
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 18px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
}

.reship_button:hover {
    background-color: var(--pm-blue);
}

.reship_button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

.reship_button-secondary {
    background-color: #6c757d;
    color: white;
}

.reship_button-secondary:hover:not(:disabled) {
    background-color: #5a6268;
}

.reship_submit-button {
    background-color: var(--green);
    font-family: var(--inter);
    color: var(--white);
    border-radius: 9px;
    width: 50%;
    margin-bottom: 10px;
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    border: none;
    cursor: pointer;
}

.reship_submit-button:hover:not(:disabled) {
    background-color: #218838;
}

.w-button-ship {
    display: inline-block;
    padding: 9px 15px;
    background-color: #3898EC;
    color: white;
    border: 0;
    line-height: inherit;
    text-decoration: none;
    cursor: pointer;
    border-radius: 0;
}

/* Error Messages */
.error-message {
    color: #dc3545;
    margin-top: 0.5rem;
    font-size: 0.875rem;
    font-weight: 500;
}

/* Thank You Popup */
.reship_thankyou-popup {
    font-family: var(--inter);
    color: var(--black);
    background-color: #00000080;
    justify-content: center;
    align-items: center;
    display: none;
    position: fixed;
    inset: 0%;
}

.reship_popup-box {
    background-color: var(--white);
    border-radius: 9px;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    width: 400px;
    padding: 30px 25px 50px;
    display: flex;
    position: relative;
}

.reship_text-block-6 {
    text-align: center;
    margin-bottom: 10px;
    font-size: 30px;
    font-weight: 700;
    line-height: 33px;
}

.reship_image-489 {
    width: 40px;
    margin-bottom: 10px;
}

.reship_text-block-7 {
    text-align: center;
    padding-bottom: 0;
    font-size: 18px;
    line-height: 24px;
}

.reship_close-popup-link {
    width: 25px;
    height: 25px;
    position: absolute;
    inset: 3% 2% auto auto;
}

/* Mobile Responsive */
@media screen and (max-width: 479px) {
    .reship_checkoutnav_div {
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        padding-top: 20px;
        padding-left: 3%;
        padding-right: 3%;
    }

    .reship_link-block-73 {
        margin-bottom: 0;
    }

    .reship_image-487 {
        height: 40px;
    }

    .reship_form-main-div {
        width: 100%;
        padding-top: 45px;
        padding-left: 3%;
        padding-right: 3%;
    }

    .reship_button {
        width: 100%;
    }

    .reship_submit-button {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .reship_link-block-74 {
        width: 52%;
    }

    .reship_popup-box {
        width: 90%;
    }

    .reship_textarea {
        width: 100%;
    }

    .reship_checkbox-item {
        padding: 12px;
        min-height: 50px;
    }

    .reship_custom-checkbox {
        width: 28px;
        height: 28px;
        margin-right: 12px;
    }

    .reship_checkbox-label {
        font-size: 14px;
    }

    .reship_form-buttons {
        flex-direction: column;
    }

    .reship_button {
        width: 100%;
        margin-bottom: 0.5rem;
    }

    .reship_popup-box {
        margin: 1rem;
        padding: 1.5rem;
    }
}
button.reship_button.w-button-ship {
    background-color: #00e0aa;
    font-family: Inter, sans-serif;
    color: #fff;
    border-radius: 9px;
    width: 50%;
    margin-bottom: 10px;
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
}

button.reship_button.w-button-ship:hover {
    background-color: #00e0aa;
    font-family: Inter, sans-serif;
    color: #fff;
    border-radius: 9px;
    width: 50%;
    margin-bottom: 10px;
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
}

.image-uploader {
        width: 100%;
        max-width: 500px;
        margin: 0 auto;
    }
    
    .upload-box {
        position: relative;
        border: 2px dashed #ccc;
        border-radius: 8px;
        padding: 20px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-bottom: 15px;
    }
    
    .upload-box:hover {
        border-color: #666;
    }
    
    .drag-over {
        border-color: #2196F3;
        background-color: rgba(33, 150, 243, 0.1);
    }
    
    .file-input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
    }
    
    .upload-content {
        padding: 20px;
    }
    
    .upload-icon {
        font-size: 48px;
        margin-bottom: 10px;
    }
    
    .upload-prompt p {
        margin: 10px 0;
        font-size: 16px;
        color: #666;
    }
    
    .file-size-info {
        font-size: 14px;
        color: #999;
        margin-top: 5px;
    }
    
    .upload-info {
        font-size: 14px;
        color: #999;
    }
    /* Add these styles to your existing CSS */

/* Upload box when file is selected */
.upload-box.has-file {
    border-color: #28a745;
    background-color: rgba(40, 167, 69, 0.1);
}

/* File selected display */
.file-selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #dee2e6;
}

.file-icon {
    font-size: 24px;
    margin-right: 12px;
    color: #28a745;
}

.file-info {
    flex: 1;
    text-align: left;
}

.file-name {
    font-weight: 600;
    color: #333;
    margin: 0 0 4px 0;
    font-size: 14px;
    word-break: break-all;
}

.file-size {
    color: #6c757d;
    font-size: 12px;
    margin: 0;
}

.remove-file-btn {
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    transition: background-color 0.2s ease;
}

.remove-file-btn:hover {
    background-color: #c82333;
}

/* Mobile responsive adjustments */
@media screen and (max-width: 479px) {
    .file-selected {
        flex-direction: column;
        text-align: center;
    }
    
    .file-icon {
        margin-right: 0;
        margin-bottom: 8px;
    }
    
    .file-info {
        margin-bottom: 8px;
    }
    
    .file-name {
        font-size: 13px;
    }
    
    .remove-file-btn {
        align-self: center;
    }
}
</style>
